var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUserAvatarFilled = function SvgUserAvatarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#18BBA8",
    d: "M26.749 24.93A13.99 13.99 0 1 0 2 16a13.9 13.9 0 0 0 3.251 8.93l-.02.017c.07.084.15.156.222.24.09.102.187.2.28.3.279.304.569.594.87.87.093.082.187.162.28.241.32.277.65.537.99.782.044.03.084.07.128.1v-.012a13.9 13.9 0 0 0 16 0v.012c.044-.03.083-.07.128-.1.34-.245.67-.506.99-.782.093-.08.187-.16.28-.242.3-.275.59-.565.87-.87.093-.1.189-.197.28-.3.071-.083.152-.155.222-.24l-.022-.016ZM16 8a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9ZM8.007 24.93A4.996 4.996 0 0 1 13 20h6a4.996 4.996 0 0 1 4.993 4.93 11.94 11.94 0 0 1-15.986 0Z"
  })));
};
export default SvgUserAvatarFilled;